<template>
<div class="custom d-inline">
<v-text-field
	:disabled="(readonly && !insideTable) || disabledValue"
	:hide-details="(!!hideDetails) ? 'hide' : false"
	:label="insideTable ? '' : label"
	:outlined="!insideTable"
	:dense="!insideTable"
	v-model="localValue"
	@change="$emit('change'); showFormatedValue = true"
	:rules="rules"
	:readonly="readonly"
	@input="$emit('input', parseFloat($event))"
	:solo="readonly && insideTable"
	@keydown.enter.prevent="$emit('keydown-enter-prevent')"
	@keydown.esc.prevent="$emit('keydown-esc-prevent')"
	@keydown.ctrl.down="$emit('keydown-ctrl-down')"
	@focus="$emit('focus'); showFormatedValue = readonly ? readonly : false"
	@blur="$emit('blur')"
	style="direction: rtl !important;"
	ref="BeeNumericField"
	:class="outerClass"
	:prefix="prefix"
></v-text-field> 
</div>
</template>
<script>
import currency from "currency.js";
import baseBeeComponent from "../../baseBeeComponent";
export default {
mixins: [baseBeeComponent],
props:["rules", "label", "value", "readonly", "insideTable", "emptyState", "disabled", "floatingPointPrecision", "hideDetails", "outerClass", "prefix"],
name:"BeeNumericField",
data(){
	return{
	showFormatedValue: true,
}},
computed:{
	localValue: {
		get: function() {
			return this.value ? 
				this.showFormatedValue ? 
					this.changeFormat(this.value) 
					/** will work like currency(this.value).value but with more 2 points precision */
					: parseFloat(this.value.toString().replace(",","")) 
				: (this.readonly ? this.emptyState : null)
		},
		set: function(value) {
			this.$emit('input', value)	
		}
	},
},
methods: {
	changeFormat(value){
		return  (value != this.emptyState && value ) ? 
			this.floatingPointPrecision == 'unlimited' ? 
				/**regex to remove trailing zeros if found. 999.123000000 became 999.123*/
				currency(value, { precision: 9, separator: ",", decimal: ".",symbol:""}).format().replace(/^0+(\d)|(\d)0+$/gm, '$1$2')
				: currency(value, { separator: ",", decimal: ".",symbol:""}).format()
			: value 
	}
},
}
</script>
<style>
.custom .v-text-field__prefix {
    color: #89a5b1 !important ;
}
.custom input {
    caret-color: auto !important;
    font-family: Calibri !important;
    font-weight: 550 !important;
    font-size: 1.05rem !important;
}
</style>